import { render } from "./drawItem.vue?vue&type=template&id=15797804&scoped=true"
import script from "./drawItem.vue?vue&type=script&lang=js"
export * from "./drawItem.vue?vue&type=script&lang=js"

import "./drawItem.vue?vue&type=style&index=0&id=15797804&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator.DESKTOP-7G84OHA\\Desktop\\dduh-active-webh5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15797804"]])

export default __exports__